import { request } from '@/utils/request'

export function trackingHttpApi(data){
  // 暂时关闭项目埋点请求
  request({url:'/web/tracking/http-api-collect.do', method:'post', data})
  return; 
}
